<template>
  <base-button type="secondary" class="clear-button mr-2" @click="clearFilters">Limpar</base-button>
</template>

<script>
export default {
	name: "ClearFiltersButton",
  methods: {
    clearFilters() {
			this.$emit('clearFilters')
    }
  }
}
</script>

<style>
.clear-button {
	width: 8.8rem;
}
</style>
